<template>
  <hm-col :grid="true" :cols="cols">
    <template v-if="!isNil(rates) && !isNil(rates.policies)">
      <hm-col cols="12">
        <template v-if="!isEmpty(rates.policies.cancellationPolicy)">
          <hm-textarea v-if="rates.policies.cancellationPolicy.freeCancellation"
                       :value="rates.policies.cancellationPolicy.humanReadableFreeCancellation"
                       :label="$t('pageRoomReservation.policies.HumanReadableFreeCancellation')"
                       disabled/>
          <hm-input-money v-else-if="!isNil(rates.policies.cancellationPolicy.cancellationFee) || rates.policies.cancellationPolicy.cancellationFee === 0"
                          :value="rates.policies.cancellationPolicy.cancellationFee"
                          :label="$t('pageRoomReservation.policies.CancellationFee')"
                          :currency="hotelSettings.details.currency"
                          disabled
          />
        </template>
        <hm-textarea :value="isEmpty(rates.policies.cancellationPolicy) ? null : rates.policies.cancellationPolicy.humanReadable"
                     :label="$t('FieldName.CancellationPolicy')"
                     disabled/>
      </hm-col>
      <hm-col cols="12">
        <hm-textarea :value="isEmpty(rates.policies.prepaymentPolicy) ? null : rates.policies.prepaymentPolicy.humanReadable"
                     :label="$t('FieldName.PrepaymentPolicy')"
                     disabled/>
      </hm-col>
      <hm-col cols="12">
        <hm-textarea :value="isEmpty(rates.policies.noShowPolicy) ? null : rates.policies.noShowPolicy.humanReadable"
                     :label="$t('FieldName.NoShowPolicy')"
                     disabled/>
      </hm-col>

      <hm-input-select ref="guaranteePolicyType"
                       v-model="rates.policies.guaranteePolicyType"
                       :label="$t('FieldName.GuaranteePolicyType')"
                       disabled
                       name="guaranteePolicyType"
                       enum-name="GuaranteePolicyType"/>
    </template>
  </hm-col>
</template>

<script>
import HmCardInner from '../layout/HmCardInner.vue';
import HmCol from '../layout/HmCol.vue';
import HmInputMoney from '../inputs/HmInputMoney.vue';
import HmInputSelect from '../inputs/HmInputSelect.vue';
import HmTextarea from '../inputs/HmTextarea.vue';
import { isEmpty, isNil } from 'lodash';
import HotelSettingsMixin from '../../../mixins/HotelSettingsMixin';

export default {
  name: 'Policies',
  components: {
    HmCardInner,
    HmCol,
    HmInputMoney,
    HmInputSelect,
    HmTextarea,
  },
  mixins: [HotelSettingsMixin],
  props: {
    rates: {},
    cols: {
      default: '12',
      type: String,
    },
  },

  computed: {
  },

  methods: {
    isNil,
    isEmpty,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lib/util/Policies.vue